<template>
  <div
    :class="[
      'session-list',
      {
        'session-list--collapsed': collapsed
      }
    ]"
  >
    <v-row
      no-gutters
      class="session-list-grid"
    >
      <v-col
        cols="12"
        sm="12"
        md="12"
        class="session-list-header-col"
      >
        <menu-header
          :collapsed="collapsed"
          @toggle-collapse="$emit('toggle-collapse')"
        />
      </v-col>

      <v-col
        cols="12"
        sm="12"
        md="12"
        class="session-list-actions-col"
      >
        <menu-actions
          :collapsed="collapsed"
          :new-chat-disabled="activeStreaming"
          :past-activity-disabled="activeStreaming"
          @new-chat="newChat"
          @past-activity="showPastActivity"
        />
      </v-col>

      <v-col
        v-if="!collapsed"
        cols="12"
        sm="12"
        md="12"
        class="session-list-recent-col"
      >
        <recent-chats
          :sessions="sessionData"
          :selected-session="selectedSession"
          :loading="loading"
          :session-selection-disabled="activeStreaming"
          @select-session="selectSession"
          @delete-session="openDeleteDialog"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import assistantService from '@/ai/services/AssistantService'

import MenuHeader from './MenuHeader.vue'
import MenuActions from './MenuActions.vue'
import RecentChats from './RecentChats.vue'

export default {
  name: 'ChatMenu',

  components: {
    MenuHeader,
    MenuActions,
    RecentChats
  },

  props: {
    collapsed: {
      type   : Boolean,
      default: false
    }
  },

  dataStore: {
    assistantStore: 'AssistantStore'
  },

  data () {
    return {
      showDeleteDialog: false,
      sessionToDelete : null
    }
  },

  computed: {
    sessionData () {
      return this.assistantStore.Sessions.Recent.Data || []
    },

    selectedSession () {
      return this.assistantStore.SelectedSession.Data
    },

    messages () {
      return this.assistantStore.Messages.Data || []
    },

    loading () {
      return this.assistantStore.Sessions.Recent.Loading
    },

    activeStreaming () {
      return this.assistantStore.Streaming.Active
    }
  },

  created () {
    this.getSessions()
  },

  methods: {
    async selectSession (session) {
      if (this.activeStreaming) {
        return
      }
      const sameSessionSelected = this.selectedSession && this.selectedSession.sessionId === session.sessionId
      if (sameSessionSelected) {
        return
      }
      this.$emit('session-item-click')
      await assistantService.selectSession(session)
    },

    async newChat () {
      if (this.activeStreaming) {
        return
      }
      this.$emit('session-item-click')
      const alreadyInNewChat = !this.selectedSession && this.messages.length === 0
      if (alreadyInNewChat) {
        return
      }
      await assistantService.newSession()
    },

    showPastActivity () {
      this.$emit('past-activity-click')
    },

    openSessionMenu (session) {
      this.$emit('session-menu-click', session)
    },

    async getSessions () {
      await assistantService.getRecentChatSessions()
    },

    openDeleteDialog (session) {
      this.$emit('delete-session', session)
    }
  }
}
</script>

<style scoped>
.session-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f4f7ff;
  color: #f4f7ff;
  overflow: hidden;
  border-right: 1px solid #ccd5e4;
  font-family: 'Inter';
  transition:
    width 0.2s ease,
    min-width 0.2s ease;
}

.session-list--collapsed {
  width: 64px;
  min-width: 64px;
}

.session-list-grid {
  width: 100%;
  height: 100%;
  min-height: 0;
  margin: 0;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: flex-start;
  gap: 0;
}

.session-list-header-col,
.session-list-actions-col {
  flex: 0 0 auto !important;
  max-width: 100%;
}

.session-list-actions-col {
  padding-bottom: 16px !important;
}

.session-list-recent-col {
  flex: 1 1 auto !important;
  min-height: 0;
  max-width: 100%;
  display: flex;
}

.session-list-recent-col > * {
  flex: 1 1 auto;
  min-height: 0;
}
</style>
